import React, {Component} from 'react';
import styles from "../../InfoCliniche/InfoCliniche.module.css";
import RadioButton from "../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../components/textbox/Input";
import Button from "../../../../../components/button/Button";
import {withTranslation} from "react-i18next";
import Utils from "../../../../../utils/Utils";
import OggettiUtili from "../../../../../utils/OggettiUtili";
import Select from "../../../../../components/select/Select"
import SelectAutocomplete from "../../../../../components/selectAutocomplete/SelectAutocomplete";
import $ from "jquery";
import Icon from "../../../../../components/icon/Icon";


class CollettivitaPostMalattia extends Component {


    state = {
        collettivitaInMalattia: {
            collettivitaFrequentata: "",
            collettivita: [{
                collettivita: "",
                numeroPersoneSuscettibili: "",
                informazioniAggiuntive: ""
            }],
            scuola: "",
            classe: "",
            sezione: "",
            corretto: false
        },

        clickCollettivitaIn: 0,
        boxesCollettivitaIn: []
    }


    constructor(props) {
        super(props);
        props.setCollettivitaPostMalattia(this.state.collettivitaInMalattia)
        this.aggiungiCollettivitaPost = this.aggiungiCollettivitaPost.bind(this)
        this.aggiungiCollettivitaPostAlloStato = this.aggiungiCollettivitaPostAlloStato.bind(this)
        this.riceviValore = this.riceviValore.bind(this)
        this.setScuola = this.setScuola.bind(this)
        this.setCollettivitaFrequentata = this.setCollettivitaFrequentata.bind(this)
        this.setValoriCollettivita = this.setValoriCollettivita.bind(this)
        this.setValoriNumeroPersoneSuscettibili = this.setValoriNumeroPersoneSuscettibili.bind(this)
        this.setValoriInfoAggiuntive = this.setValoriInfoAggiuntive.bind(this)
        this.creazioneJsonBackend = this.creazioneJsonBackend.bind(this)
        this.validate = this.validate.bind(this)
        this.uniqueObjectCollettivitaPost = this.uniqueObjectCollettivitaPost.bind(this)
        this.disabledSelectAutocomplete = this.disabledSelectAutocomplete.bind(this)
        this.disabledSelectAutocompletePostMalattia = this.disabledSelectAutocompletePostMalattia.bind(this)
        this.eliminaRow = this.eliminaRow.bind(this)
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.datiSpecifici &&
            this.props.segnalazioneCopia.datiSpecifici.collettivitaPostMalattia) {
            let propsCollettivitaPostMalattia =
                JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici.collettivitaPostMalattia));
            let collettivitaPostMalattia = this.state.collettivitaInMalattia
            collettivitaPostMalattia.collettivitaFrequentata = propsCollettivitaPostMalattia.collettivitaFrequentata
            collettivitaPostMalattia.scuola = propsCollettivitaPostMalattia.scuola
            collettivitaPostMalattia.classe = propsCollettivitaPostMalattia.classe
            collettivitaPostMalattia.sezione = propsCollettivitaPostMalattia.sezione
            collettivitaPostMalattia.collettivita = propsCollettivitaPostMalattia.collettivita ? propsCollettivitaPostMalattia.collettivita : this.state.collettivitaInMalattia.collettivita
            if (!collettivitaPostMalattia.collettivitaFrequentata) {
                collettivitaPostMalattia.corretto = false
            } else
                collettivitaPostMalattia.corretto = true
            this.setState({collettivitaPostMalattia: collettivitaPostMalattia})
            let click = 0
            if (collettivitaPostMalattia.collettivita) {
                for (let i = 0; i < collettivitaPostMalattia.collettivita.length; i++) {
                    click++
                    this.aggiungiCollettivitaPost(click)

                }
            } else {
                click++
                this.aggiungiCollettivitaPost(click)

            }
            this.props.setCollettivitaPostMalattia(this.state.collettivitaInMalattia, this)

        } else {
            this.aggiungiCollettivitaPost()

            this.props.setCollettivitaPostMalattia(this.state.collettivitaInMalattia, this)
        }


    }


    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevState.clickCollettivitaIn > this.state.clickCollettivitaIn) {
            this.aggiungiCollettivitaPost()
            let collettivitaInMalattiaPerBE = this.creazioneJsonBackend()
            this.props.setCollettivitaPostMalattia(this.state.collettivitaInMalattia, this, collettivitaInMalattiaPerBE)
        }
        if (prevState !== this.state) {
            let collettivitaInMalattiaPerBE = this.creazioneJsonBackend()
            this.props.setCollettivitaPostMalattia(this.state.collettivitaInMalattia, this, collettivitaInMalattiaPerBE)
        }

        this.disabledSelectAutocomplete()
    }

    disabledSelectAutocomplete() {
        let condizione = this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) || this.state.collettivitaInMalattia.collettivitaFrequentata !== "SI"
        this.disabledSelectAutocompletePostMalattia(condizione)
    }


    disabledSelectAutocompletePostMalattia(condizione) {

        if (condizione) {
            $("#autoselect *").attr("disabled", "disabled")


        }
    }

    validate() {

        if (this.state.collettivitaInMalattia.collettivita) {
            for (let i = 0; i < this.state.collettivitaInMalattia.collettivita.length; i++) {
                if (this.state.collettivitaInMalattia.collettivitaFrequentata === "NO" && this.state.collettivitaInMalattia.collettivita[i].collettivita) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_ASPOST"]), 1
                    )
                } else if (this.state.collettivitaInMalattia.collettivitaFrequentata === "NO" && this.state.collettivitaInMalattia.collettivita[i].numeroPersoneSuscettibili) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_ATPOST"]), 1
                    )
                } else if (this.state.collettivitaInMalattia.collettivitaFrequentata === "NO" && this.state.collettivitaInMalattia.collettivita[i].informazioniAggiuntive) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_AUPOST"]), 1
                    )
                }
            }
            let ckeckScuola = false;
            if (this.state.collettivitaInMalattia.collettivita) {
                for (let i = 0; i < this.state.collettivitaInMalattia.collettivita.length; i++) {
                    if (this.state.collettivitaInMalattia.collettivita[i].collettivita && this.state.collettivitaInMalattia.collettivita[i].collettivita === "18") {
                        ckeckScuola = true;
                        break;
                    }

                }
            }
            if (this.state.collettivitaInMalattia.collettivitaFrequentata === "NO" && this.state.collettivitaInMalattia.scuola) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_AVPOST"]), 1
                )
            } else if (!ckeckScuola && this.state.collettivitaInMalattia.scuola) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_AZPOST"]), 1
                )
            } else if (this.state.collettivitaInMalattia.collettivitaFrequentata === "NO" && this.state.collettivitaInMalattia.classe) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_BAPOST"]), 1
                )
            } else if (!ckeckScuola && this.state.collettivitaInMalattia.classe) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_BBPOST"]), 1
                )
            } else if (this.state.collettivitaInMalattia.collettivitaFrequentata === "NO" && this.state.collettivitaInMalattia.sezione) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_BCPOST"]), 1
                )
            } else if (!ckeckScuola && this.state.collettivitaInMalattia.sezione) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_BDPOST"]), 1
                )
            }

        }

        let collettivita = JSON.parse(JSON.stringify(this.state.collettivitaInMalattia.collettivita))
        let arrayCollettivitaPostPulito = Utils.removeEmptyValueFromObject(collettivita)
        let arrayNuovoPost = Utils.eliminaNullArray(arrayCollettivitaPostPulito)

        let objFinal = this.creazioneJsonBackend(this.uniqueObjectCollettivitaPost(arrayNuovoPost));
        this.props.setCollettivitaPostMalattia(this.state.collettivitaInMalattia, this, objFinal);

    }

    uniqueObjectCollettivitaPost(el) {
        const tmprscollettivitaInMalattia = new Map()
        let statoPost = JSON.parse(JSON.stringify(this.state.collettivitaInMalattia))

        const rscollettivitaInMalattia = el.reduce((acc, e) => {
            if (tmprscollettivitaInMalattia.has(e.collettivita) && tmprscollettivitaInMalattia.has(e.numeroPersoneSuscettibili) && tmprscollettivitaInMalattia.has(e.informazioniAggiuntive)) {
                if (!tmprscollettivitaInMalattia.get(e.collettivita).includes(e.jobid) && !tmprscollettivitaInMalattia.get(e.numeroPersoneSuscettibili).includes(e.jobid) && !tmprscollettivitaInMalattia.get(e.informazioniAggiuntive).includes(e.jobid)) {
                    acc.push(e)
                    tmprscollettivitaInMalattia.set(e.collettivita, [...tmprscollettivitaInMalattia.get(e.collettivita), e.jobid])
                    tmprscollettivitaInMalattia.set(e.numeroPersoneSuscettibili, [...tmprscollettivitaInMalattia.get(e.numeroPersoneSuscettibili), e.jobid])
                    tmprscollettivitaInMalattia.set(e.informazioniAggiuntive, [...tmprscollettivitaInMalattia.get(e.informazioniAggiuntive), e.jobid])
                }
            } else {
                acc.push(e)
                tmprscollettivitaInMalattia.set(e.collettivita, [e.jobid])
                tmprscollettivitaInMalattia.set(e.numeroPersoneSuscettibili, [e.jobid])
                tmprscollettivitaInMalattia.set(e.informazioniAggiuntive, [e.jobid])
            }
            return acc
        }, [])

        statoPost.collettivita = rscollettivitaInMalattia
        return statoPost
    }

    creazioneJsonBackend(statePost) {

        let collettivita = JSON.parse(JSON.stringify(statePost ? statePost : this.state.collettivitaInMalattia))
        let collettivitaInMalattiaPerBE = Utils.removeFieldFromObject(collettivita, "corretto")
        let arrayCollettivita = collettivita.collettivita ? collettivita.collettivita : []
        let arrayCollettivitaPulito = Utils.removeEmptyValueFromObject(arrayCollettivita)
        let arrayNuovo = Utils.eliminaNullArray(arrayCollettivitaPulito)
        collettivitaInMalattiaPerBE["collettivita"] = arrayNuovo
        return Utils.removeEmptyValueFromObject(collettivitaInMalattiaPerBE)
    }

    riceviValore(field, event) {
        let collettivitaInMalattia = this.state.collettivitaInMalattia;
        if (field == "classe") {
            collettivitaInMalattia.classe = event.target.value;
        } else if (field == "sezione") {
            collettivitaInMalattia.sezione = event.target.value;
        }
        this.setState({collettivitaInMalattia: collettivitaInMalattia});
    }


    setScuola(event) {
        let collettivita = this.state.collettivitaInMalattia
        collettivita.scuola = event.target.value
        this.setState({collettivitaInMalattia: collettivita});
    }

    setCollettivitaFrequentata(value) {
        let collettivita = this.state.collettivitaInMalattia
        collettivita.collettivitaFrequentata = value
        collettivita.corretto = true
        this.setState({collettivitaPreMalattia: collettivita});

    }

    setValoriCollettivita(event) {
        let click = this.state.clickCollettivitaIn - 1
        let collettivitaInMalattia = this.state.collettivitaInMalattia
        collettivitaInMalattia.collettivita[event.target.id].collettivita = event.target.value
        this.setState({collettivitaInMalattia: collettivitaInMalattia, clickCollettivitaIn: click})
    }

    setValoriNumeroPersoneSuscettibili(field, event) {
        let click = this.state.clickCollettivitaIn - 1
        let id = parseInt(field.replace("numeroPersoneSuscettibili", ""))
        let collettivitaInMalattia = this.state.collettivitaInMalattia
        collettivitaInMalattia.collettivita[id].numeroPersoneSuscettibili = event.target.value
        this.setState({collettivitaInMalattia: collettivitaInMalattia, clickCollettivitaIn: click})
    }

    setValoriInfoAggiuntive(field, event) {
        let click = this.state.clickCollettivitaIn - 1
        let id = parseInt(field.replace("informazioniAggiuntive", ""))
        let collettivitaInMalattia = this.state.collettivitaInMalattia
        collettivitaInMalattia.collettivita[id].informazioniAggiuntive = event.target.value
        this.setState({collettivitaInMalattia: collettivitaInMalattia, clickCollettivitaIn: click})
    }

    aggiungiCollettivitaPostAlloStato() {
        let collettvita = {
            collettivita: "",
            numeroPersoneSuscettibili: "",
            informazioniAggiuntive: ""
        }
        let collettivitaTotali = this.state.collettivitaInMalattia
        collettivitaTotali.collettivita.push(collettvita)
        this.setState({collettivitaInMalattia: collettivitaTotali})
    }

    eliminaRow(i){
        let collettivitaInMalattia = this.state.collettivitaInMalattia;
        let boxesCollettivitaIn = this.state.boxesCollettivitaIn
        let clickCollettivitaIn = this.state.clickCollettivitaIn
        collettivitaInMalattia.collettivita.splice(i,1)
        boxesCollettivitaIn.splice(i,1)
        this.setState({boxesCollettivitaIn: boxesCollettivitaIn, collettivitaInMalattia: collettivitaInMalattia});
        if(i===1) clickCollettivitaIn = clickCollettivitaIn - 1
        else clickCollettivitaIn = clickCollettivitaIn - 2
        this.aggiungiCollettivitaPost(clickCollettivitaIn)
        $(document).ready(function () {
            $('.selectpicker').selectpicker('refresh')
        });
    }

    aggiungiCollettivitaPost(clickInModifica) {
        const {t} = this.props
        let click = clickInModifica ? clickInModifica : this.state.clickCollettivitaIn === this.state.collettivitaInMalattia.collettivita.length ? this.state.clickCollettivitaIn : this.state.clickCollettivitaIn + 1
        let boxCollettivitaIn = [];
        let collettivita = Utils.mapToArray(OggettiUtili.Collettivita)
        if (this.props.malattia === "0578") {
            collettivita.pop()
            collettivita.push(
                {
                    "codice": "19",
                    "descrizione": "STRUTTURE SPORTIVE/PALESTRE"},
                {
                    "codice": "20",
                    "descrizione": "SAUNA"},
                {
                    "codice": "21",
                    "descrizione": "MASSAGGI"
                })
        }
        for (let i = 0; i < click; i++) {
            boxCollettivitaIn.push(
                <div>
                    <div className={"row"}>
                        <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{t("DatiSpecifici.CollettivitaMalattia.collettivita")}</p>
                            <SelectAutocomplete
                                style={{width: "100%"}}
                                value={this.state.collettivitaInMalattia.collettivita[i].collettivita}
                                field={i}
                                id={i}
                                onChange={this.setValoriCollettivita}
                                functionMap={collettivita.sort(Utils.SorterObjectDesc).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}>
                            </SelectAutocomplete>

                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <div id="sezione">
                                <p className={styles.testo}>
                                    {t("DatiSpecifici.CollettivitaMalattia.numPersone")}
                                </p>
                                <Input
                                    id={"idNumeroPersoneSuscettibiliPost" + (i)}
                                    type="number" min="0"
                                    onChange={this.setValoriNumeroPersoneSuscettibili}
                                    field={"numeroPersoneSuscettibili" + (i)}
                                    errorMessage={"Numero Persone Suscettibili non valido"}
                                    value={this.state.collettivitaInMalattia.collettivita[i].numeroPersoneSuscettibili}
                                    placeholder={"Numero Persone Suscettibili"}
                                />
                            </div>
                        </div>
                        <div className={"col-lg-3"}>
                            {
                                i>0 && !(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))?
                                    <span id={"elimina"+i}
                                          onClick={()=>
                                              this.eliminaRow(i)

                                          }
                                    ><Icon id={"it-delete"} style={{fill: "red",float: "right", marginTop: "2.2rem", cursor: "pointer"}} /></span>
                                    : <></>
                            }

                        </div>
                    </div>
                    <div>
                        <div className={"row"}>
                            <div className={"col-lg-11"}>
                        <p className={styles.testo}>{t("DatiSpecifici.CollettivitaMalattia.infoAggiuntive")}</p>
                        <Input type={"textarea"}
                               placeholder="campo a testo libero"
                               onChange={this.setValoriInfoAggiuntive}
                               value={this.state.collettivitaInMalattia.collettivita[i].informazioniAggiuntive}
                               id={"informazioniAggiuntive" + (i)}
                               field={"informazioniAggiuntive" + (i)}
                               errorMessage={"Campo informazioni aggiuntive non valido"}
                        />
                        </div></div>
                        {i < 1 ? <Button
                            classes="btn btnBluOutline "
                            disabled={this.disabledSelectAutocomplete(i)}
                            onClick={() => {
                                this.aggiungiCollettivitaPostAlloStato();
                                this.aggiungiCollettivitaPost()
                            }}
                            style={{
                                border: "none",
                                background: "none",
                                fontSize: "16px",
                                color: "#1b7ea9",
                                textDecoration: "underline"
                            }}
                            text="Aggiungi collettività "

                        /> : <div/>}
                    </div>
                </div>
            )
        }
        this.setState({clickCollettivitaIn: click, boxesCollettivitaIn: boxCollettivitaIn});
    }


    render() {
        const {t} = this.props

        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("DatiSpecifici.CollettivitaMalattia.frequentataIn")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>


                    <div className={"row"}>
                        <div>
                            <p className={styles.testo} style={{marginLeft: "8px", marginTop: "10px"}}>
                                {t("DatiSpecifici.CollettivitaMalattia.frequentata")}
                            </p>
                        </div>
                        <div style={{marginLeft: "5px"}}>
                            <RadioButton id={"collettivitaInsi"} name={"collettivitaIn"} label={"SI"}
                                         onClick={this.setCollettivitaFrequentata}
                                         smallLabel={true}
                                         value={"SI"}
                                         checked={this.state.collettivitaInMalattia.collettivitaFrequentata === "SI"}>

                            </RadioButton>
                        </div>
                        <div>
                            <RadioButton id={"collettivitaInno"} name={"collettivitaIn"} label={"NO"}
                                         onClick={this.setCollettivitaFrequentata}
                                         smallLabel={true}
                                         value={"NO"}
                                         checked={this.state.collettivitaInMalattia.collettivitaFrequentata === "NO"}>
                            </RadioButton>
                        </div>
                    </div>

                    {this.state.collettivitaInMalattia.collettivitaFrequentata !== "SI" ?
                        <div id={"autoselect"}>
                            {this.state.boxesCollettivitaIn}</div>
                        : this.state.boxesCollettivitaIn}


                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo}>{t("DatiSpecifici.CollettivitaMalattia.scuola")}</p>
                            <Select
                                value={this.state.collettivitaInMalattia.scuola}
                                onChange={this.setScuola}
                                disabled={this.state.collettivitaInMalattia.collettivitaFrequentata !== "SI"}
                                id={"scuola"}
                                functionMap={Utils.mapToArray(OggettiUtili.Scuole).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                            />
                        </div>
                        <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div>
                                <p className={styles.testo}>
                                    {t("DatiSpecifici.CollettivitaMalattia.sezione")}
                                </p>
                                <Input
                                    disabled={this.state.collettivitaInMalattia.collettivitaFrequentata !== "SI"}
                                    id={"sezione"}
                                    onChange={this.riceviValore}
                                    field={"sezione"}
                                    errorMessage={"sezione non valido"}
                                    value={this.state.collettivitaInMalattia.sezione}
                                    placeholder={"sezione"}
                                />
                            </div>
                        </div>
                        <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <div>
                                <p className={styles.testo}>
                                    {t("DatiSpecifici.CollettivitaMalattia.classe")}
                                </p>
                                <Input
                                    disabled={this.state.collettivitaInMalattia.collettivitaFrequentata !== "SI"}
                                    id={"classe"}
                                    onChange={this.riceviValore}
                                    field={"classe"}
                                    errorMessage={"classe non valido"}
                                    value={this.state.collettivitaInMalattia.classe}
                                    placeholder={"classe"}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        );
    }
}

export default withTranslation('common')(CollettivitaPostMalattia)
